export default __webpack_public_path__ + "static/media/logo_archdiocese_white_150.670c1611.png";